import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  UpdateResearchLibLinkBodyT,
  UpdateResearchLibLinkResT,
} from 'server/controllers/researchLib';

import {
  P_API_RESEARCH_LIB_LINKS,
  type ResearchLibLinkT,
  getConfig,
} from 'utils';

type UpdateResearchLibLinkArgT = {
  category: string;
  highlights: string;
  id: string;
  text: string;
  url: string;
};

export async function updateReseachLibLink({
  category,
  highlights,
  id,
  text,
  url,
}: UpdateResearchLibLinkArgT): Promise<ResearchLibLinkT> {
  assertClientSide();

  const config = await getConfig();

  const res = await axios.patch<UpdateResearchLibLinkResT>(
    `${P_API_RESEARCH_LIB_LINKS}/${id}`,
    {
      _csrf: config.CSRF,
      category,
      highlights,
      text,
      url,
    } satisfies UpdateResearchLibLinkBodyT,
  );

  return res.data;
}
